import { Link } from 'react-router-dom';

/**
 * Site footer.
 *
 * The year is computed, not written down: a hard-coded "2026" is wrong on the
 * first of January and nobody notices for months.
 */
export function Footer() {
  return (
    <footer className="app-footer">
      <Link to="/privacy">Privacy notice</Link>
      <p>
        © {new Date().getFullYear()} JW Express Delivery, LLC. Made by MACO
        Asistente. All Rights Reserved.
      </p>
    </footer>
  );
}
